module.exports = __webpack_public_path__ + "onboarding-project.3a4665f44c32db3a6bd426a4b9cf6be8.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-project.svg
// module id = 2763614514732176
// module chunks = 1